// extracted by mini-css-extract-plugin
export default {"root":"SecurityForm_root__8ZF1g","title":"SecurityForm_title__ucxyc","wrapper":"SecurityForm_wrapper__xf5lT","item":"SecurityForm_item__9pNUR"};